<script lang="ts">
	import TextWithIcon from '../textWithIcon/TextWithIcon.svelte'
	import { _ } from '@repo/i18n'
	import { CountryFlag } from '@repo/ui'
	import { Tooltip } from '@repo/ui'
	import { FetchQuery } from '@repo/ui'
	import { createQuery } from '@tanstack/svelte-query'

	interface Props {
		ip: string
	}

	let { ip }: Props = $props()

	async function getIpInfo() {
		const response = await fetch(`https://ipapi.co/${ip}/json/`)
		const ipData = await response.json()
		return ipData
	}

	const query = createQuery({
		queryKey: ['ipInfo', ip],
		queryFn: getIpInfo,
		staleTime: 1000 * 60 * 60 * 24,
	})
</script>

<TextWithIcon>
	<span>
		{ip}
	</span>

	<Tooltip>
		<FetchQuery {query}>
			{#snippet children({ data: ip })}
				<table>
					<tbody>
						{#if ip.city}
							<tr>
								<th class="pr-2 text-left">
									{$_('ip.city')}
								</th>
								<td>
									{ip.city}
								</td>
							</tr>
						{/if}
						{#if ip.region}
							<tr>
								<th class="pr-2 text-left">
									{$_('ip.region')}
								</th>
								<td>
									{ip.region}
								</td>
							</tr>
						{/if}
						<tr>
							<th class="pr-2 text-left">
								{$_('ip.country')}
							</th>
							<td>
								<CountryFlag code={ip.country_code} />
							</td>
						</tr>
					</tbody>
				</table>
			{/snippet}
		</FetchQuery>
	</Tooltip>
</TextWithIcon>
